import { AssetType } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../components/shared/components/Text';

export const AllowedAssetTypeOptions = Object.values(AssetType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
